// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"57788287","977":"62d1e39a"}[chunkId] + ".chunk.js";
};